import { Absence } from 'modules/student/dna/types';

export const absenceCalculateTotalDays = (absences: Absence[]) => {
  if (!absences.length) return 0;

  return absences.filter((absence) => absence.wholeDay).length;
};
